// src/pages/TestCategoryCreate.jsx
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Dropzone from "react-dropzone";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

export default function TestCategoryCreate() {
  const { id: testId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ name: "", image: null });
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (key, def) => translations[key] || def;

  const onDrop = files => {
    if (!files.length) return;
    const file = files[0];
    setFormData(p => ({ ...p, image: file }));
    setPreview(URL.createObjectURL(file));
  };

  const handleChange = e =>
    setFormData(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("admin_token");
      const fd = new FormData();
      fd.append("name", formData.name);
      if (formData.image) fd.append("image", formData.image);

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/test-categories/${testId}/categories`,
        fd,
        { headers: { Authorization: `Bearer ${token}` } }
      );

                  toast.success("Kayıt oluşturuldu!");
                  setTimeout(() => {
                    navigate(`/test/${testId}/category/list`);
                  }, 1000);
    } catch (err) {
      console.error(err);
      toast.error(t("CATEGORY_CREATE_ERROR", "Oluşturma başarısız"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <ToastContainer />
      <div className="card p-4 shadow-sm">
        <h5 className="mb-4">{t("ADD_CATEGORY", "Yeni Kategori Ekle")}</h5>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">{t("CATEGORY_NAME", "Kategori Adı")}</label>
            <input
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              disabled={loading}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label">
              {t("CATEGORY_IMAGE_OPTIONAL", "Resim (opsiyonel)")}
            </label>
            <Dropzone onDrop={onDrop} accept={{ "image/*": [] }} multiple={false}>
              {({ getRootProps, getInputProps }) => (
                <div
                  {...getRootProps()}
                  className="border p-3 text-center"
                  style={{ cursor: "pointer", borderStyle: "dashed" }}
                >
                  <input {...getInputProps()} />
                  {preview ? (
                    <img
                      src={preview}
                      alt=""
                      width={100}
                    />
                  ) : (
                    <p>{t("DROP_IMAGE", "Buraya resim sürükleyin veya tıklayın")}</p>
                  )}
                </div>
              )}
            </Dropzone>
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? t("SAVING", "Kaydediliyor...") : t("SAVE", "Kaydet")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
